import request from '../request';

export function addClientLead(data) {
    return request({
        url: '/dispatcher/client-leads',
        method:'post',
        data,
    })
}

export function getClientLeads(params) {
    return request({
        url:'/dispatcher/client-leads',
        method:"get",
        params,
    })
}

export function updateClientLeadStatus(data) {
    return request({
        url: `/dispatcher/client-leads/${data.id}`,
        method:'put',
        data,
    })
}

export function getLeadDetail(params) {
    return request({
        url: `/dispatcher/client-leads/${params.id}`,
        method: 'get',
    })
}

export function getSearchByStatus(params) {
    return request({
        url: '/dispatcher/client-leads-search',
        method:'get',
        params,
    })
}
